// extracted by mini-css-extract-plugin
export default {"grItemsTable":"styles_grItemsTable__WH-Lk"};